import React from "react";
import ProductoCard from "./ProductoCard";
import ProductoModal from "./ProductoModal";
import Swal from 'sweetalert2';
import CarritoRedencion from "./CarritoRedencion";
import { ProductosCampania_, RegistroRedencion_ } from '../../../services/WebAPI_Utrahuilca';
import { URLImgFront } from '../../../config/URLDB';
import Loading from '../../Loading';
import ReactDOM from 'react-dom';

class Tienda extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            productos: [],
            productoSeleccionado: null,
            mostrarModal: false,
            carrito: [],
            mostrarCheckout: false,
            filtro: false,
            totalCarrito: 0,

            estadoLoading: false,
        };
    }

    ConsultaProducto = (filtro, redencion, categoria, idconfigcampania = 32, nivelaso = 0) => {
        const body = {
            tran: filtro,
            idredencion: redencion,
            idcategoria: categoria,
            idconfigcampania: idconfigcampania,
            nivelaso: nivelaso
        };

        this.setState({
            estadoLoading: true
        });

        return ProductosCampania_(body).then(response => {
            try {
                const { data } = response;
                if (data.length > 0 && data[0].message !== "004404") {
                    const productosOptions = data.map(item => ({
                        idredencion: item.idredencion,
                        descredencion: item.descredencion,
                        valor: item.valor,
                        img: item.rutaimgprod,
                        descripcion: item.descripcion,
                        color: item.color,
                        material: item.material,
                        categoria: item.idcategoria,
                        cantidad: item.cantidaddisponible,
                        cantidadpermitida: item.cantidadpermitida
                    }));

                    if (filtro === 9) {
                        this.setState({
                            productoSeleccionado: productosOptions[0],
                        });
                    } else {
                        this.setState({
                            productos: productosOptions,
                            filtro: filtro === 8 ? !this.state.filtro : this.state.filtro
                        });
                    }
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: data[0]?.message === "004404"
                            ? 'No se encontró información de los productos!'
                            : 'Ocurrio un error!'
                    });
                }
            }
            catch (error) {
                this.setState({ error: error.toString() });
            } finally {
                this.setState({ estadoLoading: false });
            }
        })
    }

    componentDidMount() {
        this.ConsultaProducto(10, 0, 0)
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.mostrarCheckout !== this.state.mostrarCheckout) {
            this.calcularTotal();
        }
    }

    onCambiarCantidad = (idredencion, nuevaCantidad) => {
        const body = {
            tran: 6,
            idconfigcampania: 32,
            periodo: 0,
            id_cliente: this.props.idcliente,
            idredencion: idredencion,
            estado: 1,
        }
        RegistroRedencion_(body).then(result => {
            if (result.data[0].codresp.split(';')[0].trim() == "000000") {
                try {
                    this.setState(({ carrito }) => {
                        const nuevoCarrito = carrito
                            .map((item) =>
                                item.idredencion === idredencion
                                    ? { ...item, cantidad: Math.max(nuevaCantidad, 0) }
                                    : item
                            )
                            .filter((item) => item.cantidad > 0);
                        return {
                            carrito: nuevoCarrito,
                            mostrarCheckout: nuevoCarrito <= 0 ? false : true
                        };

                    });
                } catch (error) {
                    Swal.fire({ icon: 'error', title: 'Error', text: `No se pudo agregar el producto.` });
                } finally { this.calcularTotal(); }
            }
        }).catch(err => {
            Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo agregar el producto.' });
        });
    };

    abrirModal = (producto) => {
        this.ConsultaProducto(9, producto.idredencion, 0)
        document.body.style.overflow = 'hidden';
        this.setState({
            mostrarModal: true
        });
    };

    cerrarModal = () => {
        document.body.style.overflow = 'unset';
        this.setState({ mostrarModal: false, productoSeleccionado: null });
    };

    agregarAlCarrito = () => {
        const { productoSeleccionado, carrito } = this.state;
        const existe = carrito.find(p => p.idredencion === productoSeleccionado.idredencion);

        const body = {
            tran: 1,
            idconfigcampania: 32,
            periodo: 0,
            id_cliente: this.props.idcliente,
            idredencion: productoSeleccionado.idredencion,
            estado: 1,
        }

        if (existe) {
            if (existe.cantidad >= productoSeleccionado.cantidadpermitida) {
                Swal.fire({
                    icon: 'warning',
                    title: '¡No puedes redimir mas unidades de este artículo!'
                });
                document.body.style.overflow = 'unset';
                this.setState({ mostrarModal: false, productoSeleccionado: null });
                return;
            }
            RegistroRedencion_(body).then(result => {
                if (result.data[0].codresp.split(';')[0].trim() == "000000") {
                    try {
                        document.body.style.overflow = 'unset';
                        this.setState({
                            carrito: carrito.map(p =>
                                p.idredencion === productoSeleccionado.idredencion
                                    ? { ...p, cantidad: p.cantidad + 1 }
                                    : p
                            ),
                            mostrarModal: false, productoSeleccionado: null
                        });
                    } catch (error) {
                        Swal.fire({ icon: 'error', title: 'Error', text: `No se pudo agregar el producto.` });
                    }
                }
            }).catch(err => {
                Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo agregar el producto.' });
            });
        } else {
            RegistroRedencion_(body).then(result => {
                if (result.data[0].codresp.split(';')[0].trim() == "000000") {
                    try {
                        document.body.style.overflow = 'unset';
                        this.setState({
                            carrito: [...carrito, { ...productoSeleccionado, cantidad: 1 }],
                            mostrarModal: false, productoSeleccionado: null
                        });
                    } catch (error) {
                        Swal.fire({ icon: 'error', title: 'Error', text: `No se pudo agregar el producto.` });
                    }
                }
            }).catch(err => {
                Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo agregar el producto.' });
            });
        }
    };

    redimirAhora = () => {
        const { productoSeleccionado, carrito } = this.state;
        const existe = carrito.find(p => p.idredencion === productoSeleccionado.idredencion);

        const body = {
            tran: 1,
            idconfigcampania: 32,
            periodo: 0,
            id_cliente: this.props.idcliente,
            idredencion: productoSeleccionado.idredencion,
            estado: 1,
        }
        if (existe) {

            if (existe.cantidad >= productoSeleccionado.cantidadpermitida) {
                Swal.fire({
                    icon: 'warning',
                    title: '¡No puedes redimir mas unidades de este artículo!'
                });
                document.body.style.overflow = 'unset';
                this.setState({ mostrarModal: false, mostrarCheckout: true, productoSeleccionado: null });
                return;
            }
            RegistroRedencion_(body).then(result => {
                if (result.data[0].codresp.split(';')[0].trim() == "000000") {
                    try {
                        document.body.style.overflow = 'unset';
                        this.setState({
                            carrito: carrito.map(p =>
                                p.idredencion === productoSeleccionado.idredencion
                                    ? { ...p, cantidad: p.cantidad + 1 }
                                    : p
                            ),
                            mostrarModal: false, productoSeleccionado: null, mostrarCheckout: true,
                        });
                    } catch (error) {
                        Swal.fire({ icon: 'error', title: 'Error', text: `No se pudo agregar el producto.` });
                    }
                }
            }).catch(err => {
                Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo agregar el producto.' });
            });
        } else {
            RegistroRedencion_(body).then(result => {
                if (result.data[0].codresp.split(';')[0].trim() == "000000") {
                    try {
                        document.body.style.overflow = 'unset';
                        this.setState({
                            carrito: [...carrito, { ...productoSeleccionado, cantidad: 1 }],
                            mostrarModal: false, productoSeleccionado: null, mostrarCheckout: true,
                        });
                    } catch (error) {
                        Swal.fire({ icon: 'error', title: 'Error', text: `No se pudo agregar el producto.` });
                    }
                }
            }).catch(err => {
                Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo agregar el producto.' });
            });
        }
    };

    toggleFiltro = () => {
        this.setState({ filtro: !this.state.filtro });
    };

    abrirCarrito = () => {
        document.body.style.overflow = 'unset';
        this.setState({
            mostrarModal: false,
            mostrarCheckout: true,
            productoSeleccionado: null
        });
    };

    calcularTotal() {
        const total = this.state.carrito.reduce((acum, item) => { return acum + (item.valor * item.cantidad); }, 0);

        this.setState({
            totalCarrito: total
        });
    }

    render() {
        const { mostrarCheckout, mostrarModal, productos, productoSeleccionado, carrito, totalCarrito } = this.state;
        return (
            <div style={{ backgroundColor: '#FBFBFB', paddingBlockEnd: '5%' }} className="w-100 h-auto" data-aos="fade-up" data-aos-delay="3240">

                {!mostrarCheckout && (
                    <div className="d-block align-items-center" data-aos="fade-up" data-aos-delay="3240">
                        <div className="col-12 text-center px-5 py-3 py-lg-5">
                            <img src={`${URLImgFront}/assets/EstrategiasComerciales/TextoCatalogo.svg`} alt="Texto Catalogo" style={{ maxWidth: '1000px' }}></img>
                        </div>
                    </div>
                )}

                <div data-aos="fade-left" data-aos-delay="3240">
                    {!mostrarCheckout && (
                        <>
                            <div className="container-fluid mt-4">
                                <div className="row px-2 px-md-3 px-lg-5">
                                    <div className="col-md-4 d-flex flex-md-column flex-row">
                                        <div className="w-100">
                                            <div style={{ fontSize: 'clamp(20px, 4vw, 46px)' }} className="font-weight-bold font-italic">
                                                <p style={{ color: '#FF6201' }}>Filtrar por</p>
                                                <p style={{ color: '#286686' }}>Puntos</p>
                                            </div>
                                            <div style={{ color: '#989898', fontSize: 'clamp(16px, 2.5vw, 30px)', cursor: 'pointer' }}>
                                                <p onClick={() => this.ConsultaProducto(7, 1, 0)} className="m-0">Hasta 1000 puntos</p>
                                                <p onClick={() => this.ConsultaProducto(7, 2, 0)} className="m-0">1000 a 2000 puntos</p>
                                                <p onClick={() => this.ConsultaProducto(7, 3, 0)} className="m-0">Más de 2000 puntos</p>
                                            </div>
                                        </div>
                                        <div className="w-100 pb-4">
                                            <div style={{ fontSize: 'clamp(20px, 4vw, 46px)', marginTop: '50px' }} className="font-weight-bold font-italic">
                                                <p style={{ color: '#286686' }}>Categoría:</p>
                                            </div>
                                            <div style={{ color: '#707070', fontSize: 'clamp(16px, 2.5vw, 30px)', cursor: 'pointer' }}>
                                                <p onClick={() => this.ConsultaProducto(6, 0, 1)} className="m-0">Hogar</p>
                                                <p onClick={() => this.ConsultaProducto(6, 0, 2)} className="m-0">Personal</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-8">
                                        <div className={`d-flex justify-content-${this.state.carrito.length > 0 ? 'between' : 'end'} px-md-3 px-lg-5 mr-md-4 mb-4`}>
                                            <div>
                                                {this.state.carrito.length > 0 && (
                                                    <button id={"btnCarrito"} className="button-img border-0 bg-transparent" data-id={0} onClick={this.abrirCarrito} >
                                                        <img src={`${URLImgFront}/assets/EstrategiasComerciales/Carrito.svg`} alt="Carrito" style={{ width: '100%', height: '50px', touchAction: 'manipulation' }} />
                                                    </button>
                                                )}
                                            </div>
                                            <div className="dropdown d-flex ml-5 ml-md-0 " style={{ textAlign: 'right', width: '160px', alignItems: 'center' }}>
                                                <p className="border-0 bg-transparent m-0 d-inline" onClick={this.toggleFiltro} style={{ color: '#286686', cursor: 'pointer' }}> Ordenar por </p><p className="border-0 bg-transparent mb-0 d-inline ml-2" onClick={this.toggleFiltro} style={{ color: '#FF6201', cursor: 'pointer' }}>{this.state.filtro ? "ʌ" : "v"}</p>

                                                {this.state.filtro && (
                                                    <div className="position-absolute d-block" style={{ zIndex: '99', cursor: 'pointer', marginTop: '85px' }}>
                                                        <p className="bg-white px-md-4 px-2 border border-light m-0" style={{ color: '#286686', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }} onClick={() => this.ConsultaProducto(8, 1, 0)}> Menor puntos </p>
                                                        <p className="bg-white px-md-4 px-2 border border-top-0 border-light m-0" style={{ color: '#286686', borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }} onClick={() => this.ConsultaProducto(8, 2, 0)}> Mayor puntos </p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 row-cols-xl-4 w-100 px-2">
                                            {productos.map((p) => (
                                                <ProductoCard key={p.idredencion} producto={p} onDetalle={this.abrirModal} />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {mostrarModal && (
                                <ProductoModal producto={productoSeleccionado} onClose={this.cerrarModal} onAgregar={this.agregarAlCarrito} onRedimir={this.redimirAhora} puntos={this.props.puntos} />
                            )}
                        </>
                    )}
                    {mostrarCheckout && (
                        <CarritoRedencion total={totalCarrito} carrito={carrito} onVolver={() => this.setState({ mostrarCheckout: false })} cerrarOverlay={this.props.cerrarOverlay} onCambiarCantidad={this.onCambiarCantidad} idcliente={this.props.idcliente} nombre={this.props.nombre} correo={this.props.correo} celular={this.props.celular} nit={this.props.nit} tipoiden={this.props.tipoiden} />
                    )}
                </div>
                {this.state.estadoLoading && (
                    ReactDOM.createPortal(
                        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 999999999, backgroundColor: 'rgba(0,0,0,0.4)', overflowY: 'auto', paddingTop: '120px' }} className="d-flex align-items-start align-items-md-center justify-content-center" >
                            <div style={{ position: 'absolute', top: 0, left: 0, height: '100%', width: '100%', overflow: 'hidden', zIndex: 99999999 }}>
                                <Loading alto={'100%'} />
                            </div>
                        </div>,
                        document.body)
                )}
            </div>
        );
    }
}

export default Tienda;